import { t } from 'i18next'
import React, { useContext, useReducer } from 'react'
import { getTenantInfoByKey, getUserBuilding, getUserOpening } from '../../helpers/helpers'
import { confirmAccessService, getAccessContractorsService, checkAccessService, confirmExitService } from '../../services/access'
import AccessVehiclesContext from '../AccessVehiclesContext/AccessVehiclesContext'
import AccessContext from './AccessContext'
import AccessReducer from './AccessReducer'
import { logout } from '../../services/login'
import AccessAreaContext from '../AccessAreaContext/AccessAreaContext'
import AccessPersonToVisitContext from '../AccessPersonToVisitContext/AccessPersonToVisitContext'
import AccessEquipmentContext from '../AccessEquipment/AccessEquipmentContext'

const AccessState = ({ children }) => {
    const initialState = {
        error: false,
        message: '',
        isFetching: true,
        contractors: [],
        employee: null,
        visit: null,
        step: '',
        type: '',
        accessWithCar: false,
        accessWithEquipmentOrTools: false,
        confirmingMovement: false,
        errorType: ''
    }

    const [state, dispatch] = useReducer(AccessReducer, initialState);

    const { setAccessVehiclesSelected } = useContext(AccessVehiclesContext);
    const { setAccessArea } = useContext(AccessAreaContext);
    const { setAccessPersonsToVisitSelected } = useContext(AccessPersonToVisitContext);
    const { setAccessEquipmentsSelected } = useContext(AccessEquipmentContext);

    const movementsErrors = {
        NO_PARAM: 'NO_PARAM',
        PARAM_ERROR: 'PARAM_ERROR',
        NON_ACTIVE_RESOURCE: 'NON_ACTIVE_RESOURCE',
        NONEXISTENCE_ENTITY: 'NONEXISTENCE_ENTITY',
        CONCURRENCY_ERROR: 'CONCURRENCY_ERROR',
        STATUS_ERROR: 'STATUS_ERROR',
        AUTH_ERROR: 'AUTH_ERROR',
        INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
        PROFILE_ACCESS_ERROR: 'PROFILE_ACCESS_ERROR',
        NOT_ACCESS_OPENING: 'NOT_ACCESS_OPENING',
        BUILDINGS_WITHOUT_OPENING: "BUILDINGS_WITHOUT_OPENING",
        MANDATORY_PEOPLE_TO_VISIT: "MANDATORY_PEOPLE_TO_VISIT",
        MAXIMUM_PEOPLE_TO_VISIT: "MAXIMUM_PEOPLE_TO_VISIT",
        EQUIPMENT_NOT_EXIST_OR_DISABLED: "EQUIPMENT_NOT_EXIST_OR_DISABLED ",
    }

    const setType = (newType) => {
        dispatch({ type: 'SET_TYPE', payload: newType })
    }

    const setStep = (newStep) => {
        dispatch({ type: 'SET_STEP', payload: newStep })
    }

    const setAccessWith = (access) => {
        dispatch({
            type: 'SET_ACCESS_WITH',
            payload: access
        })
    }

    const setVisit = (visit) => {
        dispatch({ type: 'SET_VISIT', payload: visit });
    }

    const setExitEmployee = (exitEmployee) => {
        const isVisit = exitEmployee.id === null;

        const haveArea = exitEmployee.area !== null;

        const area = haveArea ?
            {
                "area_id": exitEmployee.area.area_id,
                "code": exitEmployee.area.area_code,
                "description": exitEmployee.area.area_description
            }
            :
            {
                "area_id": '',
                "code": "",
                "description": t('FREE_ACCESS_AREA')
            }

        const personsVisited = exitEmployee.people_visited !== null ?
            exitEmployee.people_visited.map(peopleVisited => ({
                "peopleToVisitId": peopleVisited.people_to_visit_id,
                "documentNumber": peopleVisited.document_number,
                "name": peopleVisited.name,
                "lastName": peopleVisited.last_name,
                ...(peopleVisited.sector) ?
                    {
                        "sector": {
                            "sectorId": peopleVisited.sector.sector_id,
                            "sectorName": peopleVisited.sector.name
                        }
                    }
                    :
                    {
                        "sector": null
                    },
            }))
            :
            []

        const equipments = exitEmployee.equipments_access !== null ?
            exitEmployee.equipments_access.map(equipmentsAccess => ({
                id: {
                    value: equipmentsAccess.equipment_type_id,
                    label: equipmentsAccess.equipment_description,
                },
                details: equipmentsAccess.equipment_detail
            }))
            :
            []

        setAccessEquipmentsSelected(equipments)

        setAccessPersonsToVisitSelected(personsVisited);

        setAccessArea(area);

        if (isVisit) {
            setType('EXIT_VISIT');

            setVisit({
                ...exitEmployee,
                full_name: exitEmployee.fullname,
                document: exitEmployee.natural_id,
                reason: exitEmployee.visit_reason,
            });

            const theVisitHaveVehicles = exitEmployee.vehicles.length !== 0;

            const visitVehicles = exitEmployee.vehicles.map(visitVehicles => ({ description: visitVehicles.vehicle_description, plate_number: visitVehicles.vehicle_natural_id }));

            setAccessWith({ accessWithCar: theVisitHaveVehicles })

            setAccessVehiclesSelected(visitVehicles)

            setStep('DETAIL')

            return
        };

        dispatch({
            type: 'SET_EMPLOYEE',
            payload: exitEmployee
        });

        const theEmployeeHaveVehicles = exitEmployee.vehicles.length !== 0;

        setAccessWith({ accessWithCar: theEmployeeHaveVehicles })

        setAccessVehiclesSelected(exitEmployee.vehicles);

        setStep('DETAIL')

    }

    const setAccessEmployee = (employee) => {
        const isBlocked = employee.blocked === true;
        const isNotAptAndBlockIfIsNotNotApt = getTenantInfoByKey('block_ingress_if_is_not_ok') === true && employee.access_status?.employee_general_status === 2 && employee.access_status?.is_excepted === false;
        const isAssignToOpening = employee.assign_to_opening === false;
        const notActiveEmpIsAllowToAccess = employee.not_active_emp_is_allow_to_access === true;
        const notActiveEmpIsNotAllowToAccess = employee.not_active_emp_is_allow_to_access === false;
        const employeeWithFutureIncome = employee.employee_with_future_income === true;
        const isVisit = employee.id === null;
        const isInOtherBuilding = employee.is_in_other_building !== null;

        if (isBlocked) {
            dispatch({
                type: 'CANT_ACCESS_EMPLOYEE',
                payload: { employee, message: t('EMPLOYEE_NO_ACCESS_ERROR') }
            });
            return
        };

        if (isAssignToOpening) {
            dispatch({
                type: 'CANT_ACCESS_EMPLOYEE',
                payload: { employee, message: t('EMPLOYEE_NO_ACCESS_OPENING_ERROR') }
            });
            return
        };

        if (employeeWithFutureIncome) {
            dispatch({
                type: 'CANT_ACCESS_EMPLOYEE',
                payload: { employee, message: t('EMPLOYEE_HAVE_FUTURE_INCOME_ERROR') }
            });
            return
        };

        if (notActiveEmpIsAllowToAccess) {
            setType('ACCESS_VISIT');
            setVisit({
                ...employee,
                full_name: employee.fullname,
                document: employee.natural_id,
                reason: '',
            });
            setStep('VISIT_FORM');
            return
        };

        if (isNotAptAndBlockIfIsNotNotApt) {
            dispatch({
                type: 'CANT_ACCESS_EMPLOYEE',
                payload: { employee, message: t('EMPLOYEE_NO_ACCESS_ERROR') }
            });
            return
        };

        if (notActiveEmpIsNotAllowToAccess) {
            dispatch({
                type: 'CANT_ACCESS_EMPLOYEE',
                payload: { employee, message: t('EMPLOYEE_NO_ACCESS_ERROR') }
            });
            return
        };

        if (isVisit) {
            setType('ACCESS_VISIT');
            setVisit({
                ...employee,
                full_name: employee.fullname,
                document: employee.natural_id,
                reason: '',
            });
            setStep('VISIT_FORM');
            return
        };

        if (isInOtherBuilding) {
            dispatch({
                type: 'CANT_ACCESS_EMPLOYEE',
                payload: { employee, message: `${t('THE_RESOURCE_IS_ALREADY_IN')} ${getTenantInfoByKey('building_name')} ${employee.is_in_other_building.building_code} ${employee.is_in_other_building.building_description}` }
            });
            return
        };

        dispatch({
            type: 'SET_EMPLOYEE',
            payload: employee
        });
        setStep('ACCESS_WITH');

    }

    const checkIsEmployeeOrVisit = async (IDENTIFICATION) => {
        try {
            const response = await getAccessContractorsService(IDENTIFICATION, getUserOpening().codigo, getUserBuilding().buildingId);
            if (response.ok) {
                setType('ACCESS');

                dispatch({
                    type: 'GET_ACCESS_CONTRACTORS',
                    payload: response.data.response
                });

                const isNewVisit = response.data.response === null;

                if (isNewVisit) {
                    setType('ACCESS_VISIT');
                    setStep('VISIT_FORM');
                    return
                }

                const areOnlyOneResult = response.data.response.length === 1;

                if (areOnlyOneResult) {
                    setAccessEmployee(response.data.response[0]);
                    return
                }

            } else {
                const errorType = await response.data.json();
                switch (errorType.error_code) {
                    case 'AUTH_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('TOKEN_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('PERMISSIONS_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('ERROR_DATA_ENTER')
                        })
                        break;
                }
            }
        } catch (e) {
            dispatch({
                type: 'ERROR_SERVER',
                payload: t('SERVER_ERROR')
            })
            console.log(e)
        }
    }

    const checkAccess = async (IDENTIFICATION) => {
        try {
            const response = await checkAccessService(IDENTIFICATION, getUserOpening().codigo, getUserBuilding().buildingId);
            if (response.ok) {
                const noResourceInside = response.data.response.length === 0;
                if (noResourceInside) {
                    checkIsEmployeeOrVisit(IDENTIFICATION);
                    return
                }

                setType('EXIT');
                const areOnlyOneResult = response.data.response.length === 1;
                if (areOnlyOneResult) {
                    setExitEmployee(response.data.response[0])
                    return
                }

                dispatch({
                    type: 'GET_ACCESS_CONTRACTORS',
                    payload: response.data.response
                });
            } else {
                const errorType = await response.data.json();
                switch (errorType.error_code) {
                    case 'AUTH_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('TOKEN_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('PERMISSIONS_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('ERROR_DATA_ENTER')
                        })
                        break;
                }
            }
        } catch (e) {
            dispatch({
                type: 'ERROR_SERVER',
                payload: t('SERVER_ERROR')
            })
            console.log(e)
        }
    }

    const clean = () => {
        dispatch({ type: 'CLEAN' })
    }

    const confirmAccess = async (accessValues) => {
        try {
            dispatch({ type: 'CONFIRMING_MOVEMENT' })
            const response = await confirmAccessService(accessValues);
            if (response.ok) {
                dispatch({ type: 'CONFIRM_ACCESS' })
            } else {
                const errorType = await response.data.json()
                const errorCode = movementsErrors[errorType.error_code] ? errorType.error_code : 'INTERNAL_SERVER_ERROR';
                dispatch({ type: 'ERROR_ACCESS', payload: errorCode });
                if (['AUTH_ERROR', 'PROFILE_ACCESS_ERROR'].some(errorLogoutType => errorCode === errorLogoutType)) {
                    setTimeout(() => {
                        logout();
                    }, 1000);
                }
            }
        } catch (e) {
            dispatch({ type: 'ERROR_ACCESS', payload: 'INTERNAL_SERVER_ERROR' })
            console.log(e)
        }
    }

    const confirmExit = async (exitValues) => {
        try {
            dispatch({ type: 'CONFIRMING_MOVEMENT' })
            const response = await confirmExitService(exitValues);
            if (response.ok) {
                dispatch({ type: 'CONFIRM_EXIT' })
            } else {
                const errorType = await response.data.json();
                const errorCode = movementsErrors[errorType.error_code] ? errorType.error_code : 'INTERNAL_SERVER_ERROR';
                dispatch({ type: 'ERROR_ACCESS', payload: errorCode });
                if (['AUTH_ERROR', 'PROFILE_ACCESS_ERROR'].some(errorLogoutType => errorCode === errorLogoutType)) {
                    setTimeout(() => {
                        logout();
                    }, 1000);
                }
            }
        } catch (e) {
            dispatch({ type: 'ERROR_ACCESS', payload: 'INTERNAL_SERVER_ERROR' })
            console.log(e)
        }
    }

    return (
        <AccessContext.Provider
            value={{
                accessState: state,
                checkAccess,
                setAccessEmployee,
                setExitEmployee,
                clean,
                setStep,
                setAccessWith,
                confirmAccess,
                confirmExit,
                setVisit
            }}
        >
            {children}
        </AccessContext.Provider>
    )
}

export default AccessState